<template>
    <b-row>
        <b-col cols="12">
            <h2 class="m-0 h3 text-uppercase">{{ $t('partido.elige_asientos') }}</h2>
            <h3 class="subtitle h4 light mb-3 ">{{ $t('partido.varios_asientos') }}</h3>
        </b-col>
        <b-col cols="12" lg="6">
            <div class="oswald text-uppercase">{{ $t('partido.zona_seleccionada') }}:</div>
            <span class="h2 mb-1 d-block">
                {{ zona.name }}
                <br>
                <button @click="reset" class="h6 button small-button m-0" ><i class="fa fa-redo"></i> {{ $t('partido.cambiar_zona') }}</button>
                <button v-if="zona.imagen_panoramica" @click="showModal('imagen-panoramica')" type="button" class="h6 button small-button m-0 ml-2">VER 360º</button>
                <ImagenPanoramica v-if="zona.imagen_panoramica" name="imagen-panoramica" :url="this.zona.imagen_panoramica" :title="title" v-on:close="() => close()"/>
            </span>

            <div v-if="zona.imagen" class="mb-3">
                <img :src="zona.imagen">
            </div>

            <ContentOrLoading style="min-height: 250px;">
                <TusAsientosComponent
                    v-if="!loading"
                    :precios="zona.precios"
                    :asientos="asientos"
                    :puedo_cambiar="! disabled && precios_seleccionados.length === 0"
                    :puedo_continuar="! disabled"
                    :asientos_minimos="asientos_minimos"
                    :precios_seleccionados="precios_seleccionados"
                    @continuar="bloquearAsientos"
                ></TusAsientosComponent>
            </ContentOrLoading>
        </b-col>
        <b-col cols="12" lg="6" class="order-first order-lg-last">
            <div v-if="zona.with_seats">
                <AsientosComponent
                    :zona="zona"
                    :asientos="asientos"
                    :asientos_maximos="asientos_maximos"
                    :disabled="disabled"
                    :pack="pack"
                    :sesiones_ids="sesiones_ids"
                    @asientoSeleccionado="asientoSeleccionado"
                ></AsientosComponent>
            </div>
            <div v-else>
                <p class="oswald text-uppercase mt-lg-4">{{ $t('partido.numero_entradas', {entradas: 'entradas'}) }} {{ footer.termino_entradas }}</p>
                <div class="form-group">
                    <multiselect
                        v-model="n_entradas"
                        :placeholder="$t('partido.numero_entradas', {entradas: 'entradas'})"
                        :show-labels="false"
                        :options="options"
                        :allow-empty="false"
                    ></multiselect>
                </div>
            </div>
        </b-col>
    </b-row>
</template>

<script>
import TusAsientosComponent from "@/components/frontend/events/compra/TusAsientosComponent.vue";
import ImagenPanoramica from "@/components/common/ImagenPanoramica.vue";
import AsientosComponent from "@/components/frontend/packs/venta/con_recinto/components/AsientosComponent.vue";
export default {
    props: {
        zona: {
            required: true,
            type: Object
        },
        pack: {
            type: Object,
            required: true
        },
        disabled: {
            type: Boolean,
            required: false
        },
        asientos_maximos: {
            type: Number,
            default: 5
        },
        asientos_minimos: {
            type: Number,
            default: 1
        },
        sesiones_ids: {
            required: true,
            type: Array
        },
        precios_seleccionados: {
            required: false,
            type: Array,
            default() {
                return []
            }
        }
    },
    data() {
        return {
            asientos: [],
            n_entradas: 0,
            loading: false
        }
    },
    watch: {
        n_entradas() {
            const datos = [];
            for (let i = 0; i < this.n_entradas; i++) {
                datos.push({
                    'apellidos': '',
                    'asiento': {
                        'region_id': this.zona.id,
                        'asiento': 0,
                        'fila': 0,
                        'zona_nombre': this.zona.name
                    },
                    'dni': '',
                    'es_nuevo': true,
                    'nombre': '',
                    'precio': '',
                    'precios': this.zona.precios,
                    'telefono': '',
                    'url_imprimir': ''
                });
            }
            this.asientos = datos;
        }
    },
    computed: {
        options() {
            var tope = this.asientos_maximos;

            if(this.zona.libres < tope) {
                tope = this.zona.libres;
            }

            var opciones = [];

            for(var i = 1; i <= tope; i++) {
                opciones.push(i);
            }

            return opciones;
        },
        configuracion() {
            return this.$store.getters.getConfig;
        },
        footer() {
            return this.$store.getters.getFooter;
        },
    },
    methods: {
        showModal(modal) {
            this.$modal.show(modal);
        },
        close(modal) {
            this.$modal.hide(modal);
        },
        asientoSeleccionado(row, seat) {
            let delete_index = null;
            this.asientos.forEach(function(asiento, index) {
                if(asiento.asiento.fila == row && asiento.asiento.asiento == seat) {
                    delete_index = index;
                }
            });

            if(delete_index != null) {
                this.asientos.splice(delete_index, 1);
            } else {
                let precio = null
                if(this.precios_seleccionados.length > 0) {
                    console.log(this.precios_seleccionados[this.asientos.length]);
                    precio = this.precios_seleccionados[this.asientos.length];
                }

                let data_asiento = {
                    asiento : {
                        region_id :  this.zona.id,
                        fila : parseInt(row),
                        asiento : parseInt(seat),
                        zona_nombre: this.zona.name
                    },
                    precios: this.zona.precios
                };

                if(precio != null) {
                    data_asiento.asiento.event_ticket_id = precio;
                }

                this.asientos.push(data_asiento);
            }
        },
        bloquearAsientos() {
            this.$emit('terminado', this.asientos);
        },
        reset() {
            this.$emit('reset');
        }
    },
    components: {
        AsientosComponent,
        TusAsientosComponent, ImagenPanoramica
    }
}
</script>